import router from '@/Router';

export const goBackFallback = fallback => {
  if (router.history.previous?.matched?.length) {
    router.back();
  } else {
    router.push(fallback);
  }
};
